/** Default external landing page for the Explant book (overridable in admin). */
export const DEFAULT_EXTERNAL_BOOK_URL = 'https://explant.healing-women.com';

/**
 * Normalizes book navigation fields on `book_info` payloads from the API or admin forms.
 * @param {Record<string, unknown>} bookInfo
 */
export function normalizeBookNavFields(bookInfo) {
  const raw = bookInfo && typeof bookInfo === 'object' ? bookInfo : {};
  const book_destination = raw.book_destination === 'internal' ? 'internal' : 'external';
  const urlRaw = raw.external_book_url;
  const external_book_url =
    typeof urlRaw === 'string' && urlRaw.trim() ? urlRaw.trim() : DEFAULT_EXTERNAL_BOOK_URL;
  return { ...raw, book_destination, external_book_url };
}

export function getPublicBookHref(bookInfo) {
  const b = normalizeBookNavFields(bookInfo);
  if (b.book_destination === 'internal') return '/book';
  return b.external_book_url;
}

export function isExternalBookDestination(bookInfo) {
  return normalizeBookNavFields(bookInfo).book_destination === 'external';
}
